<form novalidate #setupForm="ngForm">
  <div class="setup-container">
    <div class="section-container">
      <div class="section-label identity">Identity</div>
      <div class="section-data">
        <nrwl-test-identity
          [testName]="testName"
          [customer]="customerName"
          [technician]="technicianName"
          [contact]="contact"
          [email]="email"
          [phone]="phone"
          [technicianId]="technicianId"
          [comments]="comments"
          [editMode]="editMode || cloneMode"
          (updateTestIdentity)="updateTestIdentity($event)"
        ></nrwl-test-identity>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">Endpoints</div>
      <div class="endpoint-section">
        <nrwl-agent-picker
          [testType]="'y1731-initiator'"
          [originatorDevice]="selectedOriginator"
          [editMode]="editMode"
          [showTestMode]="false"
          (emitAgents)="onAgentChange($event)"
        ></nrwl-agent-picker>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">Setup</div>
      <div class="section-data">
        <div class="group">
          <div class="label">Source MAC Address</div>
          <input
            matInput
            autocomplete="off"
            type="text"
            class="input-data width-200 float-left"
            name="srcMacAddress"
            #srcMacAddressInput="ngModel"
            [(ngModel)]="formField.srcMacAddress"
            (ngModelChange)="onSourceMacAddressChange()"
            [pattern]="macRegex"
            required
          />
          <div
            class="error error-space"
            *ngIf="
              srcMacAddressInput.invalid && (srcMacAddressInput.dirty || srcMacAddressInput.touched)
            "
          >
            <mat-error *ngIf="srcMacAddressInput?.errors?.required"> Required</mat-error>
            <mat-error *ngIf="srcMacAddressInput.errors?.pattern"
              >Mac Address is not a valid</mat-error
            >
          </div>
        </div>
        <div class="group">
          <div class="label">MEP ID</div>
          <input
            matInput
            autocomplete="off"
            type="number"
            class="input-data width-75 float-left"
            name="mepIdInput"
            #mepIdInput="ngModel"
            [(ngModel)]="formField.mepId"
            (ngModelChange)="onMepIdInputChange()"
            min="1"
            max="8191"
            required
          />
          <div
            class="error clr-float"
            *ngIf="mepIdInput.invalid && (mepIdInput.dirty || mepIdInput.touched)"
          >
            <mat-error *ngIf="mepIdInput.errors?.min || mepIdInput.errors?.max">
              Value should be 1 to 8191</mat-error
            >
          </div>
        </div>
        <div class="group">
          <div class="label">PM Report Interval</div>
          <mat-select
            name="pmReportInterval"
            class="option-list"
            #pmReportIntervalInput="ngModel"
            [(ngModel)]="formField.pmReportInterval"
            (selectionChange)="onPmReportIntervalChange()"
          >
            <mat-option *ngFor="let type of pmReportIntervalTypes" [value]="type.value">{{
              type.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">Persist after Reboot</div>
          <mat-select
            class="option-list width-75"
            #persistAfterRebootInput="ngModel"
            [(ngModel)]="formField.persistAfterReboot"
            name="persistAfterReboot"
            (selectionChange)="onPersistAfterRebootChange()"
            required
          >
            <mat-option *ngFor="let item of persistAfterRebootSelection" [value]="item.value">{{
              item.name
            }}</mat-option>
          </mat-select>
        </div>
      </div>
    </div>
    <div class="section-container network_container">
      <div class="label-data label">
        <span class="network_label">Network</span>
      </div>
      <div class="network_configuration_row">
        <div class="vlan">
          <label>VLAN Config</label>
          <mat-select
            class="option-list"
            #vlanConfigInput="ngModel"
            name="vlanConfigInput"
            [(ngModel)]="formField.vlanConfig"
            (ngModelChange)="onVlanConfigChange()"
          >
            <mat-option *ngFor="let mode of vlanConfigTypes" [value]="mode.value">
              {{ mode.name }}</mat-option
            >
          </mat-select>
        </div>
        <div class="lan_container" *ngIf="formField.vlanConfig !== 'untagged'">
          <div class="svlan">
            <label *ngIf="formField.vlanConfig !== 'tagged'">S-VLAN</label
            ><label *ngIf="formField.vlanConfig === 'tagged'">VLAN</label>
            <input
              matInput
              type="number"
              class="network_row_input"
              #sVlanInput="ngModel"
              name="sVlanInput"
              [(ngModel)]="formField.svlan"
              required
              min="1"
              max="4095"
              (ngModelChange)="onSVlanChange()"
            />
            <span
              class="error"
              *ngIf="sVlanInput.invalid && (sVlanInput.dirty || sVlanInput.touched)"
            >
              <mat-error *ngIf="sVlanInput.errors.required">Vlan is required</mat-error>
              <mat-error *ngIf="sVlanInput.errors.min || sVlanInput.errors.max"
                >Valid range 1 and 4065</mat-error
              >
            </span>
          </div>
          <div class="spriority">
            <label *ngIf="formField.vlanConfig !== 'tagged'">S-VLAN Priority</label
            ><label *ngIf="formField.vlanConfig === 'tagged'">VLAN Priority</label>
            <input
              matInput
              type="number"
              class="network_row_input"
              #sVlanPriorityInput="ngModel"
              name="sVlanPriorityInput"
              [(ngModel)]="formField.svlanPriority"
              required
              min="0"
              max="7"
              [disabled]="editMode"
              (ngModelChange)="onSVlanPriorityChange()"
            />
            <span
              class="error"
              *ngIf="
                sVlanPriorityInput.invalid &&
                (sVlanPriorityInput.dirty || sVlanPriorityInput.touched)
              "
            >
              <mat-error *ngIf="sVlanPriorityInput.errors.required"
                >Vlan Priority is required</mat-error
              >
              <mat-error *ngIf="sVlanPriorityInput.errors.min || sVlanPriorityInput.errors.max"
                >Valid range 0 and 7</mat-error
              >
            </span>
          </div>
          <div class="cvlan" *ngIf="formField.vlanConfig !== 'tagged'">
            <label>C-VLAN</label>
            <input
              matInput
              type="number"
              class="network_row_input"
              #cVlanInput="ngModel"
              name="cVlanInput"
              [(ngModel)]="formField.cvlan"
              required
              min="1"
              max="4065"
              (ngModelChange)="onCVlanChange()"
            />
            <div
              class="error"
              *ngIf="cVlanInput.invalid && (cVlanInput.dirty || cVlanInput.touched)"
            >
              <mat-error *ngIf="cVlanInput.errors.required">C-Vlan is required</mat-error>
              <mat-error *ngIf="cVlanInput.errors.min || cVlanInput.errors.max"
                >Valid range 1 and 4065</mat-error
              >
            </div>
          </div>
          <div class="cpriority" *ngIf="formField.vlanConfig !== 'tagged'">
            <label>C-VLAN Priority</label>
            <input
              matInput
              type="number"
              class="network_row_input"
              #cVlanPriorityInput="ngModel"
              name="formField.cVlanPriorityInput"
              [(ngModel)]="formField.cvlanPriority"
              (ngModelChange)="onCVlanPriorityChange()"
              required
              min="0"
              max="7"
              [disabled]="editMode"
            />
            <div
              class="error"
              *ngIf="
                cVlanPriorityInput.invalid &&
                (cVlanPriorityInput.dirty || cVlanPriorityInput.touched)
              "
            >
              <mat-error *ngIf="cVlanPriorityInput.errors.required"
                >C-Vlan Priority is required</mat-error
              >
              <mat-error *ngIf="cVlanPriorityInput.errors.min || cVlanPriorityInput.errors.max"
                >Valid range 0 and 7</mat-error
              >
            </div>
          </div>
          <div *ngIf="formField.vlanConfig !== 'tagged'">
            <label>Ethertype</label>
            <mat-select
              class="option-list"
              #cvlanEthertypeInput="ngModel"
              name="cvlanEthertypeInput"
              [(ngModel)]="formField.cvlanEtherType"
              (ngModelChange)="onCVlanEtherTypeChange()"
            >
              <mat-option *ngFor="let ether of etherTypesData" [value]="ether.value">{{
                ether.name
              }}</mat-option>
            </mat-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
